import React, {Dispatch, SetStateAction} from "react";
import {
    AllStates,
    asJsonformsErrorTranslate,
    asJsonformsTranslate,
    JSON_FORMS_CONFIG,
    StepForm,
    TranslateFunction
} from '../Forms';

import schema from './base.schema.json';

import {JSONSchema7} from "json-schema";
import {JsonForms} from "@jsonforms/react";
import uischema from "./base.uischema.json";
import {materialCells, materialRenderers} from "@jsonforms/material-renderers";
import {Base} from "./Base";
import {I18nMessage} from "../Representation";

export const EMPTY_BASE: Base = {
    "study_program": {
        "subject": undefined
    },
    "personal_data": {
        "surname": undefined,
        "given_name": undefined,
        "birthday": undefined,
        "birthplace": undefined
    }
}

const FORM_NS = "base_form.";

export class BaseForm extends StepForm {

    constructor() {
        super(schema as JSONSchema7);
    }

    getFormNs(): string | undefined {
        return FORM_NS;
    }

    getTitleKey() {
        return "base_title"
    };

    getPage([formData, setFormData]: [any, Dispatch<SetStateAction<any>>],  allStates: AllStates, t: TranslateFunction, lang: string) {
        return (<React.Fragment>
            <JsonForms
                schema={schema}
                uischema={uischema}
                data={formData}
                renderers={materialRenderers}
                cells={materialCells}
                config={JSON_FORMS_CONFIG}
                i18n={{
                    translate: asJsonformsTranslate(t, FORM_NS),
                    locale: lang,
                    translateError: asJsonformsErrorTranslate(t)
                }}
                onChange={({data}) => setFormData(data)}
            />
        </React.Fragment>);
    }

    getContextMessageKeys = (data: any, _allStates: AllStates): [I18nMessage[], I18nMessage[]] => {
        const baseData = ((data as unknown) as Base);
        if (baseData === undefined) {
            return [[], []];
        }
        return [[], []];
    }

    getExplanationMarkdownKey() {
        return "base.explanation.markdown";
    }

    getHelpUrl(): string {
        return "faq.html#base-information";
    }

}